<div class="container-fluid speedo_mater h-100">
  <div class="row speedo_border h-100">
    <div class="col py-3 pl-3">
      <p>{{ "DASHBOARD.SPEEDOMATER.TITLE" | translate }}</p>
      <p class="my-1">{{ "DASHBOARD.SPEEDOMATER.DESCR" | translate }}</p>
      <p class="mt-0">{{ "DASHBOARD.SPEEDOMATER.DESCRVAL" | translate }}</p>
      <div class="assessment-text">
        <h2 *ngIf="rate" class="text-center" >{{rate}}/10 - {{"DASHBOARD.SPEEDOMATER.RATINGS." + rates[rate] | translate }}</h2>
        <h2 *ngIf="!rate" class="text-center" ></h2>
        <small>( 2 {{ "DASHBOARD.SPEEDOMATER.RATINGS.INS" | translate }}- 4 {{ "DASHBOARD.SPEEDOMATER.RATINGS.SCARSO" | translate }} - 6 {{ "DASHBOARD.SPEEDOMATER.RATINGS.MEDIO" | translate }} - 8 {{ "DASHBOARD.SPEEDOMATER.RATINGS.BUONO" | translate }} - 10 {{ "DASHBOARD.SPEEDOMATER.RATINGS.OTTIMO" | translate }} )</small>
      </div>
    </div>
    <div class="col-4 p-0">
      <img class="img-fluid position-absolute w-100" src="../../../../assets/img/concierge-verde.svg" alt="" srcset="">
    </div>
  </div>
</div>
